import Navbar from "../components/Navbar";
import Searchbar from "../components/Searchbar";
import OverviewTitle from "../components/OverviewTitle";
import map from "../assets/map.png";
import logo from "../assets/1stsunergy.png";
import Review from "../components/Review";
import SuggestedCard from "../components/SuggestedCards";
import addReviewIcon from "../assets/addReview.svg";
import ContactForm from "../components/ContactForm";
import Footer from "../components/Footer";
import starIcon from "../assets/starIcon.svg";
import solar3g from "../assets/3gsolar.png";
import es2 from "../assets/2es.png";
import energy3D from "../assets/3d_energy.png";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import OptimizedIframe from "../components/OptimizedFrame";
import CountryStore from "../store/CountryStore";
import CategoryStore from "../store/CategoryStore";
import axios from "axios";
import { ClipLoader } from "react-spinners";
import Card from "../components/Card";
import CityBreadCrumb from "../components/CityBreadCrumb";
import BrowseByCities from "../components/BrowseByCities";
import CityListStore from "../store/cityListStore";
import VendorLayout from "../components/VendorLayout";

function OverviewPage() {
  const [vendorDetails, setVendorDetails] = useState([]);
  const [cardsData, setCardsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const country = CountryStore((state) => state.country);
  const category = CategoryStore((state) => state.category);
  const location = useLocation();
  const slug = location.state?.slug;
  const cityList = CityListStore((state) => state.cityList);
  // console.log(slug)

  async function fetchRemarks() {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("company_slug", slug);
      const response = await fetch("/api/get_vendor_detail.php", {
        method: "POST",
        body: formData,
      });
      // console.log(await response.json());
      const data = await response.json();
      // console.log('vendor details:'+data[0]);
      setVendorDetails(data[0]);
      setLoading(false);
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  }

  async function fetchNearVendors() {
    setLoading(true);
    try {
      if (country === "Country" || !category) {
        // console.log("Country and category are required");
        return;
      }
      const formData = new FormData();
      formData.append("cat_slug", category);
      formData.append("country_name", country);
      formData.append("popular", "asc");
      const response = await axios.post(
        "/api/get_category_vendor_list.php",
        formData
      );
      const responseStr = response.data;
      try {
        const citiesIndex = responseStr.indexOf('{"cities":');
        if (citiesIndex !== -1) {
          const vendorsStr = responseStr.substring(0, citiesIndex);
          const vendorsData = JSON.parse(vendorsStr);
          const filtered = vendorsData.filter(
            (item, index, self) =>
              index ===
              self.findIndex((t) => t.company_name === item.company_name)
          );
          setCardsData(filtered);
          // setCardsData(vendorsData);
          // console.log(vendorDetails);
        } else {
          console.log("Could not find cities data in response");
          setCardsData(JSON.parse(responseStr));
        }
      } catch (parseError) {
        console.error("Error parsing response:", parseError);
        console.error("Response string:", responseStr);
      }
      setLoading(false);
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchRemarks();
    fetchNearVendors();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [slug]);

  // const filters = [
  //   { label: "All", count: null, active: true },
  //   { label: "Only positive", count: 46, active: false },
  //   { label: "Only negative", count: 2, active: false },
  // ];

  // const reviews = [
  //   {
  //     name: "Randy W.",
  //     date: "November 19, 2024",
  //     rating: 5,
  //     review:
  //       "Sunergy made it super smooth and easy to get solar. We had need of a large system to sustain a lot of computing, EV usage, and heatpump, so ended up drafting out a 12.75kW array. Their representative John Parlator kept in close contact through the whole process.",
  //     likes: 6,
  //     dislikes: 0,
  //   },
  //   {
  //     name: "John Parlatore",
  //     date: "November 10, 2024",
  //     rating: 5,
  //     review:
  //       "John Parlatore was great to work with, from start to finish. He was prompt with getting back to me in a timely and every step was handled with professionalism. I would recommend Sunergy to anyone who is thinking of getting solar panels. They look great and will save us tens of thousands.",
  //     likes: 13,
  //     dislikes: 2,
  //   },
  // ];

  // const nearbyBusinesses = [
  //   {
  //     logo: solar3g,
  //     name: "3G-Solar GmbH",
  //   },
  //   {
  //     logo: es2,
  //     name: "2ES",
  //   },
  //   {
  //     logo: energy3D,
  //     name: "3D Energy",
  //   },
  // ];

  return (
    <div className="font-inter flex flex-col min-h-screen">
      <Navbar />

      <div className="container mx-auto px-4 sm:px-6 md:px-6 lg:px-8 xl:px-16 2xl:px-24 my-10 mt-5">
        <div className="flex flex-wrap items-center justify-between gap-4">
          <CityBreadCrumb path={vendorDetails.title} />
        </div>

        <div className="min-h-[200px]">
          {loading ? (
            <div className="h-[200px] w-full flex justify-center items-center bg-white">
              <ClipLoader color="#006b4f" size={35} speedMultiplier={1} />
            </div>
          ) : (
            <OverviewTitle
              logo={vendorDetails.logo}
              name={vendorDetails.title}
              rating={4.9}
              reviewCount={48}
              location={vendorDetails.address}
              phone={vendorDetails.callNo}
              website={vendorDetails.website}
              description={vendorDetails.vendor_description}
              mapImage={map}
              senderEmail={vendorDetails.email}
            />
          )}
        </div>

        <VendorLayout vendorDetails={vendorDetails} />

        <div className="">
          <h2 className="my-6 text-xl sm:text-2xl lg:text-3xl font-semibold">
            Nearby similar businesses
          </h2>
          <div className="flex justify-center items-center">
            {loading ? (
              <div className="py-10">
                <ClipLoader color="#006b4f" size={35} speedMultiplier={1} />
              </div>
            ) : (
              <div
                className={`grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4`}
              >
                {cardsData
                  .filter((card) => slug !== card.slug)
                  .slice(0, 3)
                  .map((card) => (
                    <SuggestedCard
                      key={card.slug}
                      slug={card.slug}
                      logo={card.logo}
                      name={card.company_name}
                      address={card.address}
                    />
                  ))}
              </div>
            )}
          </div>
        </div>
        <BrowseByCities cityData={cityList} />
      </div>

      <Footer />
    </div>
  );
}

export default OverviewPage;

{
  /* Review Section 
  <div className="flex flex-wrap items-center justify-between mb-6">
    <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold">
      Reviews
    </h2>
    <div className="flex items-center gap-2">
      <img
        src={starIcon}
        className="w-5 h-5 text-orange-400 fill-orange-400"
        alt="rating"
      />
      <span className="font-medium text-base lg:text-lg">4.8</span>
      <span className="text-gray-500 text-sm lg:text-base">
        (127)
      </span>
    </div>
  </div>

  <div className="flex flex-wrap items-center gap-4 mb-8">
    {filters.map((filter, index) => (
      <button
        key={index}
        className={`px-4 py-2 rounded-full text-sm lg:text-base ${
          filter.active
            ? "border-2 border-gray-900"
            : "border border-gray-200 hover:border-gray-300"
        }`}
      >
        {filter.label}
        {filter.count !== null && ` (${filter.count})`}
      </button>
    ))}
    <button className="flex items-center gap-2 ml-auto text-red-500 hover:text-red-600">
      <img src={addReviewIcon} alt="add review" />
    </button>
  </div>

  <div className="mb-8 space-y-6">
    {reviews.map((review, index) => (
      <Review key={index} {...review} />
    ))}
  </div> */
}

{
  /* <div className="flex flex-wrap items-center gap-2">
    {[1, 2, 3, 4, "...", 26].map((page, index) => (
      <button
        key={index}
        className={`w-8 h-8 flex items-center justify-center rounded-full ${
          page === 1 ? "bg-gray-100" : "hover:bg-gray-50"
        }`}
      >
        {page}
      </button>
    ))}
  </div> */
}
